import { defineComponent as _defineComponent } from 'vue'
import MiniAuth from '@/components/meeting-request/auth-verification.vue'
import PaymentReconfirm from '@/components/retry-payment/payment-reconfirm.vue'

import Loader from '@/components/loader.vue';

import { httpsCallable } from 'firebase/functions'
import {functions} from '../util/firebase'

import { watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import {ref} from 'vue'
import { checkLoggedIn } from '@/util/auth';
import { Userspaces, Meetings, DataInstance, Transactions } from '@busy-human/opt-library';
import { useUserspace } from '@/store/userspace';

enum RetryStage {
    LOGIN,
    PAYMENTINFO,
    SUCCESS,
    FAILED,
    PROCESSING
}


export default /*#__PURE__*/_defineComponent({
  __name: 'retry-payment',
  setup(__props, { expose }) {
  expose();

const stage = ref(RetryStage.PAYMENTINFO);

const route = useRoute();
const router = useRouter();

const noScroll = ref(false)
const loading = ref(true)

const meeting = ref<DataInstance<Meetings.Model> | null>(null)
const transaction = ref<DataInstance<Transactions.Model> | null>(null)

const user = ref<DataInstance<Userspaces.Model> | null>(null)
const recipient = ref<DataInstance<Userspaces.Model> | null>(null)

const authorizedMeeting = ref(false)
const wrongUser = ref(false)
const pastMeeting = ref(false)

const isLoggedIn = ref(false)

const userspace = useUserspace();

watch(() => route.params.meetingLink, async meetingLink => {
    loading.value = true
    if(meetingLink) {
        meeting.value = null
        user.value = null
        recipient.value = null
        authorizedMeeting.value = false

        if(checkLoggedIn()){
            isLoggedIn.value = true
        }else{
            isLoggedIn.value = false
            stage.value = RetryStage.LOGIN
        }

        let meetingData = await Meetings.Collection.fetchMeetingForLink(meetingLink as string)
        if(!meetingData){
            console.log("Couldn't find meeting")
            loading.value = false
            return
        }

        const meetingType = meetingData.type

        //This page should only be accessable by a payer link
        if(meetingType == 'collector'){
            loading.value = false
            return
        }
        
        meeting.value = meetingData.meeting as DataInstance<Meetings.Model>

        if(isLoggedIn.value && meeting.value.payer !== userspace.uid){
            wrongUser.value = true
            loading.value = false
            return
        }

        if(!meeting.value.transactionId) {
            console.error("Meeting without transactionId", meeting.value.$id);
            return;
        }

        let transactionRef = Transactions.Collection.docEntity(meeting.value.transactionId)
        transactionRef.fetch()
        transaction.value = transactionRef.data()

        if(transaction.value.status === 'complete'){
            authorizedMeeting.value = true
        }
        // let now = new Date(Date.now()).toISOString()
        // if(meeting.value!.startTime < now)
        //     pastMeeting.value = true

        user.value = {
            ...(await Userspaces.Collection.fetchDoc(meeting.value.payer)).data() as Userspaces.Model,
            $id: meeting.value.payer
        }
        recipient.value = {
            ...(await Userspaces.Collection.fetchDoc(meeting.value.collector)).data() as Userspaces.Model,
            $id: meeting.value.collector
        }

        let now = new Date(Date.now()).toISOString()
        if(Meetings.canMeetingBeConfirmed( meeting.value ))
            pastMeeting.value = true
    }
    loading.value = false
}, {immediate: true})

const authOpen = ref(false)
const showLogin = ref(false)
const miniLogin = () => {
    authOpen.value = true;
    showLogin.value = true
}

const miniSignup = () => {
    authOpen.value = true;
}

const updateUserDetails = () => {
    wrongUser.value = false
    if(checkLoggedIn() && meeting.value) {
        if(meeting.value.payer !== userspace.uid) 
            wrongUser.value = true
        stage.value = RetryStage.PAYMENTINFO
    }
}

const retryPayment = async () => {
    const retryPayment = httpsCallable<{meeting: Meetings.Model, transaction: Transactions.Model }, string>(functions, 'retryPayment');

    const result = await retryPayment({meeting: meeting.value! as DataInstance<Meetings.Model>, transaction: transaction.value!});

    if(result.data === 'SUCCESS') stage.value = RetryStage.SUCCESS
    else if(result.data === 'FAILED') stage.value = RetryStage.FAILED
    else if(result.data === 'PROCESSING') stage.value = RetryStage.PROCESSING
}

const routeTo = (route:string) =>{
    router.push(`/${route}`);
}


const __returned__ = { RetryStage, stage, route, router, noScroll, loading, meeting, transaction, user, recipient, authorizedMeeting, wrongUser, pastMeeting, isLoggedIn, userspace, authOpen, showLogin, miniLogin, miniSignup, updateUserDetails, retryPayment, routeTo, MiniAuth, PaymentReconfirm, Loader, httpsCallable, functions, watch, useRoute, useRouter, ref, checkLoggedIn, Userspaces, Meetings, DataInstance, Transactions, useUserspace }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})